module.exports = __webpack_public_path__ + "img/logo-full-competti-big-min.5a1859a0.png";